import axios from 'axios';
import axiosRetry from 'axios-retry';
import toastr from 'toastr';
import * as actions from './actionsTypes';
import errorManage from '../../errorManage';
import messages from '../../messages';

const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const getMeasurements = data => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_MEASUREMENTS,
      payload: true
    });
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.get(`/api/app/Clima_Sub_Objeto/`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      },
      params: data
    });
    dispatch({
      type: actions.GET_MEASUREMENTS,
      payload: {
        measurements: resp.data.data,
        measurementsLength: resp.data.count
      }
    });
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_MEASUREMENTS,
      payload: false
    });
  }
}

export const saveMeasurements = data => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_MEASUREMENTS,
      payload: true
    });

    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.post('/api/app/Clima_Sub_Objeto/', data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }});
    const { measurements, measurementsLength } = getState().measurements;
    const aMeasurements = [...measurements, resp.data];
    dispatch({
      type: actions.GET_MEASUREMENTS,
      payload: {
        measurements: aMeasurements,
        measurementsLength: measurementsLength + 1
      }
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.SAVE_LOADER_MEASUREMENTS,
      payload: false
    });
  }
}

export const editMeasurements = (data, id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_MEASUREMENTS,
      payload: true
    });
  
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.put(`/api/app/Clima_Sub_Objeto/${id}/`, data, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    }});
    const { measurements, measurementsLength } = getState().measurements;
    measurements[index] = resp.data;
    dispatch({
      type: actions.GET_MEASUREMENTS,
      payload: {
        measurements: measurements,
        measurementsLength: measurementsLength
      }
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_MEASUREMENTS,
      payload: false
    });
  }
}

export const deleteMeasurements = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_MEASUREMENTS,
      payload: true
    });
    
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    await client.delete(`/api/app/Clima_Sub_Objeto/${id}/`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    }});
    const { measurements, measurementsLength } = getState().measurements;
    measurements.splice(index, 1);
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_MEASUREMENTS,
      payload: {
        measurements: measurements,
        measurementsLength: measurementsLength -1
      }
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_MEASUREMENTS,
      payload: false
    });
  }
}
